//catagoriesData
import products5 from 'assets/images/products/img-5.png';
import products8 from 'assets/images/products/img-8.png';
import products11 from 'assets/images/products/img-11.png';
import products16 from 'assets/images/products/img-16.png';

//ellipsCategories
import products1 from "assets/images/products/img-1.png";
import products6 from "assets/images/products/img-6.png";
import products15 from "assets/images/products/img-15.png";
import products18 from "assets/images/products/img-18.png";
import products20 from "assets/images/products/img-20.png";

//sliderCategories
import products4 from "assets/images/products/img-4.png";
import products9 from "assets/images/products/img-9.png";
import products12 from "assets/images/products/img-12.png";
import products17 from 'assets/images/products/img-17.png';

export const catagoriesData = [
    {
        id: 1,
        img: products5,
        title: 'Footwear'
    },
    {
        id: 2,
        img: products16,
        title: 'Electronics'
    },
    {
        id: 3,
        img: products8,
        title: "Men's"
    },
    {
        id: 4,
        img: products11,
        title: "Women's"
    },
]

export const ellipsCategories = [
    {
        id: 1,
        img: products6,
        title: "Clothes",
        product: "96",
        bg: "warning"
    },
    {
        id: 2,
        img: products20,
        title: "Electronics",
        product: "25",
        bg: "dark"
    },
    {
        id: 3,
        img: products18,
        title: "Cosmetic",
        product: "10",
        bg: "warning"
    },
    {
        id: 4,
        img: products1,
        title: "Bags",
        product: "58",
        bg: "danger"
    },
    {
        id: 5,
        img: products15,
        title: "Handbags & Clutches",
        product: "64",
        bg: "info"
    },
    {
        id: 6,
        img: products5,
        title: "Footwear",
        product: "342",
        bg: "danger"
    },
]

export const sliderCategories = [
    {
        id: 1,
        img: products15,
        title: "Handbags & Clutches",
        bg: "dark"
    },
    {
        id: 2,
        img: products17,
        title: "Electronics",
        bg: "dark"
    },
    {
        id: 3,
        img: products4,
        title: "Footwear",
        bg: "success"
    },
    {
        id: 4,
        img: products12,
        title: "Furniture & Decor",
        bg: "danger"
    },
    {
        id: 5,
        img: products18,
        title: "Beauty, Health, Grocery",
        bg: "warning"
    },
    {
        id: 6,
        img: products9,
        title: "Men's Accessories",
        bg: "dark"
    },

]